import { useCallback, useMemo } from 'react';
import OrderFullscreenModal from './common/OrderFullscreenModal';
import { useOrderRemoteCollaboration } from '../../../../hooks/order/useOrderRemoteCollaboration';
import { useOrderContext } from '../../../../providers/OrderProvider';
import OrderFullscreenModalBody from './common/OrderFullscreenModalBody';
import OrderModalFooter from './common/OrderModalFooter';
import OrderModalHeader from './common/OrderModalHeader';
import OrderDetailModalBody from './common/OrderDetailModalBody';

const PrePaymentModal = ({ setIsOpenPendingModal, isOpenPendingModal }) => {
	const { order, isLoading } = useOrderContext();
	const { handleRemoteOrderUpdate } = useOrderRemoteCollaboration('payment', {
		enabled: isOpenPendingModal,
	});
	const { orderId, customerInfo, approvalStatus, isCompleted } = order ?? {};

	const handleClose = useCallback(() => {
		setIsOpenPendingModal(false);
	}, [setIsOpenPendingModal]);

	const prePaymentStatusBadge = useMemo(() => order?.uiHints?.modalStatusBadges?.default ?? null, [order]);

	return (
		<OrderFullscreenModal show={isOpenPendingModal} onHide={handleClose}>
			<OrderModalHeader
				orderId={orderId}
				customerInfo={customerInfo}
				isLoading={isLoading}
				isCompleted={isCompleted}
				approvalStatus={approvalStatus}
				badges={prePaymentStatusBadge ? [prePaymentStatusBadge] : []}
			/>
			<OrderFullscreenModalBody isLoading={isLoading}>
				<OrderDetailModalBody
					pendingFocus='prePayment'
					notesType='pay'
					paymentScheduleModelName='PrePaymentModal'
					contractTooltipId='prepayment-contract-toggle-tooltip'
					invoiceTooltipId='prepayment-invoice-toggle-tooltip'
				/>
			</OrderFullscreenModalBody>
			<OrderModalFooter onRemoteOrderUpdate={handleRemoteOrderUpdate} />
		</OrderFullscreenModal>
	);
};

export default PrePaymentModal;
